import { Outlet } from "react-router-dom"
import { Header } from "../components/header"
import { SideBar } from "../components/sidebar"

export function DashboardLayout(){
	return <>
	<Header />
	<div className="row" id="DashboardLayout">
		<SideBar />
		<Outlet />
	</div>
	</>
}